import CdnMixin from '@SHARED/js/Vue/mixins/CdnMixin';
import froalaGlobalConfig from '@ADMIN/js/froala/config';
import template from './FroalaField.html';
import MediaGalleryModule from '../../MediaGallery/MediaGalleryModule';

/*
 * Wrapper for https://github.com/froala/vue-froala-wysiwyg
 */
export default {
  name: 'FroalaField',

  template,

  mixins: [CdnMixin],

  components: {
    MediaGalleryModule,
  },

  props: {
    relatedId: {
      type: Number,
      required: true,
    },
    relatedModel: {
      type: String,
      required: true,
    },
    initContent: {
      type: Object,
      required: true,
    },
    uniqueId: String,
  },

  data() {
    return {
      content: this.initContent,
      froalaInstance: null,
      renderGallery: false,
      froalaConfig: null,
    };
  },

  watch: {
    content() {
      this.$emit('content-change', this.content);
    },
  },

  beforeDestroy() {
    this.$refs.editor.destroyEditor();
  },

  created() {
    // Register custom button in Froala
    $.FroalaEditor.DefineIcon('galleryIcon', { NAME: 'image' });
    $.FroalaEditor.RegisterCommand(`gallery${this.uniqueId}`, {
      title: 'Gallery',
      icon: 'galleryIcon',
      undo: false,
      focus: true,
      showOnMobile: true,
      refreshAfterCallback: true,
      callback: this.openGallery,
    });

    // Moved from Vue data to here, to prevent froalaGlobalConfig from being passed as reference instead of as a copy.
    this.froalaConfig = {
      initOnClick: true,
      charCounterCount: false,
      placeholderText: 'Skriv tekst her...',
      toolbarButtons: [
        'fullscreen',
        'bold',
        'italic',
        'underline',
        'strikeThrough',
        '|',
        'fontSize',
        'color',
        'paragraphStyle',
        'paragraphFormat',
        '|',
        'blockquote',
        'align',
        'formatOL',
        'formatUL',
        '|',
        // Since commands are shared between all instances of Froala,
        // we need to ensure 'gallery' is unique in order to trigger the correct MediaGalleryModal instance
        `gallery${this.uniqueId}`,
        'insertLink',
        'insertVideo',
        'insertTable',
        '|',
        'specialCharacters',
        'insertHR',
        'selectAll',
        'clearFormatting',
        '|',
        'help',
        'html',
        '|',
        'undo',
        'redo',
      ],
      quickInsertButtons: froalaGlobalConfig.quickInsertButtons,
      paragraphStyles: froalaGlobalConfig.paragraphStyles,
      linkStyles: froalaGlobalConfig.linkStyles,
      linkMultipleStyles: false,
      imageStyles: froalaGlobalConfig.imageStyles,
      imageEditButtons: froalaGlobalConfig.imageEditButtons,
      videoResponsive: true,
      videoResize: false,
      videoDefaultDisplay: 'block',
      videoDefaultWidth: 0,
      videoEditButtons: froalaGlobalConfig.videoEditButtons,
      videoInsertButtons: froalaGlobalConfig.videoInsertButtons,
      pastePlain: true,
      entities: '', // Prevent Froala from encoding html entities
      imageUploadRemoteUrls: false,
      imageUploadParam: 'file',
      imageUploadURL: window.imageApiStoreUrl,
      imageUploadMethod: 'POST',
      imageUploadParams: {
        image_upload_destination: window.aws.uploadPath,
        absolute_image_path: window.aws.cdnPath,
      },
      events: {
        'froalaEditor.initializationDelayed': (e, editorInstance) => {
          this.froalaInstance = editorInstance;
        },
        'froalaEditor.file.inserted': function (e, editorInstance) {
          // Force trigger content changed
          // (workaround for Froala not triggering contentChanged when file is inserted)
          editorInstance.events.trigger('contentChanged');
        },
      },
    };

    this.validateContent(this.content);
  },


  // Methods

  methods: {
    openGallery() {
      this.renderGallery = true;
      this.$nextTick(() => {
        this.$refs.froalaFieldGallery.initOnFroalaEditor();
      });
    },

    insertFromGallery(event) {
      try {
        event.media.forEach((mediaItem) => {
          if (mediaItem.file_type === 'image') {
            this.froalaInstance.html.insert(`<img src="${this.cdn(mediaItem.path, { w: 850 })}" class="fr-fil img-fluid fr-dib fr-draggable">`);
          } else {
            this.froalaInstance.html.insert(`<a href="${mediaItem.path}">Link lagt til..</a>`);
          }
        });

        // Force trigger event (workaround for Froala not triggering contentChanged)
        this.froalaInstance.events.trigger('file.inserted');
      } catch (err) {
        throw new Error(err);
      }

      this.$refs.froalaFieldGallery.destroyGallery();
      this.$nextTick(() => {
        this.renderGallery = false;
      });
    },

    validateContent(content) {
      if (typeof content.froala_content !== 'string') {
        throw new Error('Invalid content given to FroalaField');
      }

      return true;
    },
  },

};
